window.Project = function() {
    var el = this;
    var autosaveId = 0;
    el.current = {};
    
    el.load = function(sid) {
        el.loader.show('Загрузка проекта фотокниги...');
        el.request.get('/api/interior/projects/get/' + sid, function(response) {
            el.loader.hide();
            
            if (response.hasOwnProperty('error')) {
                alert(response.error.description);
                return false;
            }

            if (response.hasOwnProperty('project')) {
                if (parseInt($.cookie('saved_company')) !== parseInt(response.project.company_id)) {
                    alert('Выбранная фотокнига привязана к другой компании.');
                    return false;
                }

                window.bookSid = response.project.id + '_' + response.project.hash;
                el._parent.isCheckingOnloadStatus = true;
                el._parent.workData = {};
                el.current = response.project;
                
                el.format.init();
                
                if (Object.keys(response.project.constructor).length > 0) {
                    el._parent.workData = response.project.constructor;
                } else {
                    el.workarea.init();
                }
                
                el._parent.valve = parseInt(el.currentProduct.company.valve / el.MM_IN_PIXELS / el.workData.scale);
                
                el.calculator.init();
                el.format.render();
                
                el.upImages.init();
                el.workarea.render();
                el.startAutoSave();
                el.history.init();

                if (el.enforceLogin === 1) {
                    el.dialog.show('login', {domain: encodeURIComponent(window.location.origin), disable_close: true});
                    el._parent.isCheckingOnloadStatus = false;
                }
            }
        }, 'json');
    };
    
    el.save = function(cb) {
        el.loader.show('Сохранение проекта интерьерки...');
        var data = {
            calculator: JSON.stringify(el.calculator.data),
            data: JSON.stringify(el.workData)
        };
        el.request.post('/api/interior/projects/update/' + window.bookSid, data, function (response) {
            el.loader.hide();
            if (response.hasOwnProperty('error')) {
                alert(response.error.description);
                el.loader.hide();
                return false;
            } else {
                if (cb !== undefined) {
                    cb();
                }
            }
        }, 'json', false);
    };
    
    el.startAutoSave = function() {
        autosaveId = setInterval(function() {
            var data = {
                calculator: JSON.stringify(el.calculator.data),
                data: JSON.stringify(el.workData)
            };
        
            el.request.post('/api/interior/projects/update/' + window.bookSid, data, function (response) {
                if (response.hasOwnProperty('error')) {
                    alert(response.error.description);
                    clearTimeout(autosaveId);
                }
            }, 'json');
        }, 30000);
    };

    el.stopAutoSave = function () {
        clearTimeout(autosaveId);
    };

    $(document).on('click', '.js-project-save', function () {
        el.save();
    });
};